import { render, staticRenderFns } from "./ItemFilterDefaultFilter.vue?vue&type=template&id=68361a82&scoped=true"
import script from "./ItemFilterDefaultFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilterDefaultFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68361a82",
  null
  
)

export default component.exports